import React, { ReactNode } from 'react';
import clsx from 'clsx';

const Wrapper = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => {
  return <div className={clsx('mx-6 my-8', className)}>{children}</div>;
};

export default Wrapper;
